import React from "react";
import { useKT } from "../i18n/kt";
import { fmtDay, fmtRange, rupees } from "../rates/rateModel";
import { CORRECTION_TITLE, correctionBalance, correctionKind, correctionLeft, correctionWhat, PayCorrection } from "./paySheetModel";

/**
 * A pay sheet line's corrections: paid work removed (or moved or corrected for less) since it was
 * paid, each as a labelled minus line, then the balance to recover, what this sheet takes back
 * (at most half the period's wages, advance cut included), what is left for later sheets, and the
 * server's warning.
 */
const CorrectionLines = ({ line }: { line: any }) => {
  const { t } = useKT();
  const list: PayCorrection[] = Array.isArray(line?.corrections) ? line.corrections : [];
  const b = correctionBalance(line);
  if (!list.length && !b.outstanding && !b.carried && !line?.warning) return null;
  return (
    <div className="kps-corrections">
      {list.map((c, i) => (
        <div key={c.key || c.entryId || i} className="kps-correction">
          <span>
            <strong>{t("Correction")}</strong> · {t(CORRECTION_TITLE[correctionKind(c)][0], { what: correctionWhat(c, fmtDay, fmtRange) })}
            {c.reason ? ` · “${c.reason}”` : ""}
            {c.byName ? ` · ${t("by {{name}}", { name: c.byName })}` : ""}
            {correctionLeft(c) != null ? <small> · {t("{{left}} left", { left: rupees(correctionLeft(c)) })}</small> : null}
          </span>
          <strong className="kps-correction__amt">{rupees(c.amount)}</strong>
        </div>
      ))}
      {b.outstanding ? (
        <div className="kps-correction">
          <span>{t("Correction to recover")}</span>
          <strong className="kps-correction__amt">{rupees(b.outstanding)}</strong>
        </div>
      ) : null}
      {b.outstanding || b.taken ? (
        <div className="kps-correction">
          <span>{t("Taken back on this sheet")}</span>
          <strong className="kps-correction__amt">{rupees(-b.taken)}</strong>
        </div>
      ) : null}
      {b.carried ? (
        <div className="kps-correction">
          <span>{t("Left to recover on later sheets")}</span>
          <strong className="kps-correction__amt">{rupees(b.carried)}</strong>
        </div>
      ) : null}
      {line?.warning ? (
        <p className="kps-correction__warn" role="note">
          {t(line.warning)}
        </p>
      ) : null}
    </div>
  );
};

export default CorrectionLines;
